import { render, staticRenderFns } from "./Inboxes.vue?vue&type=template&id=82993d9a&scoped=true&"
import script from "./Inboxes.vue?vue&type=script&lang=js&"
export * from "./Inboxes.vue?vue&type=script&lang=js&"
import style0 from "./Inboxes.vue?vue&type=style&index=0&id=82993d9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82993d9a",
  null
  
)

export default component.exports